<template>
  <span>
    <router-link v-if="linkRoute" class="font-weight-bold" :to="linkRoute">{{ link }}</router-link>
    <b v-else>{{ link }}</b>
  </span>
</template>

<script>
export default {
  props: {
    dataId: {
      type: String,
      default: null
    },
    link: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: null
    }
  },
  computed: {
    linkRoute() {
      if (this.type === "hashtag") {
        if (!this.link) {
          this.$reportError(new Error("DynamicLink: link is null"))
          return "/hashtag/"
        }
        return `/hashtag/${this.link.replace("#", "")}`
      }
      if (this.type === "mention") {
        return `/profile/${this.dataId}`
      }
      return null
    }
  }
}
</script>
